import React from 'react';
import { motion } from 'framer-motion';
export function Footer() {
  return <footer className="relative z-10 py-12 px-4 border-t border-white/5 bg-slate-950/50 backdrop-blur-lg" data-id="element-34">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-35">
        <div className="flex items-center gap-2" data-id="element-36">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center font-bold text-white" data-id="element-37">
            J
          </div>
          <span className="text-xl font-bold tracking-tight text-white" data-id="element-38">
            Jeucapital
          </span>
        </div>

        <div className="text-slate-500 text-sm flex flex-col md:flex-row items-center gap-4 md:gap-8" data-id="element-39">
          <span data-id="element-40">Warszawa, Poland</span>
          <span data-id="element-41">© 2026 Jeucapital. All rights reserved.</span>
        </div>
      </div>
    </footer>;
}